import { defineMessages } from 'react-intl';
const messages = defineMessages({
    Add: {
        id: 'Add',
        defaultMessage: 'Add',
    },
    ShowWeekend: {
        id: 'ShowWeekend',
        defaultMessage: 'Show weekend',
    },
    WeekendTasksTooltip: {
        id: 'WeekendTasksTooltip',
        defaultMessage: '{count} task(s) in the weekend this week',
    },
    AllDay: {
        id: 'AllDay',
        defaultMessage: 'All day',
    },
    CalendarConnectionError: {
        id: 'CalendarConnectionError',
        defaultMessage: 'There is a problem with your calendar connection. Please reconnect it.',
    },
    NewTask: {
        id: 'NewTask',
        defaultMessage: 'New task',
    },
    WeekPlanner: {
        id: 'WeekPlanner',
        defaultMessage: 'Week planner',
    },
    ForEmployee: {
        id: 'ForEmployee',
        defaultMessage: 'For employee',
    },
    SelectTask: {
        id: 'SelectTask',
        defaultMessage: 'Select task',
    },
    Status: {
        id: 'Status',
        defaultMessage: 'Status',
    },
    ExecutionDateFrom: {
        id: 'ExecutionDateFrom',
        defaultMessage: 'Execution date from',
    },
    ExecutionDateUntil: {
        id: 'ExecutionDateUntil',
        defaultMessage: 'Execution date until',
    },
    TaskTemplates: {
        id: 'TaskTemplates',
        defaultMessage: 'Task templates',
    },
    SubtractOneWeek: {
        id: 'SubtractOneWeek',
        defaultMessage: '-1 week',
    },
    CurrentWeek: {
        id: 'CurrentWeek',
        defaultMessage: 'Current week',
    },
    AddOneWeek: {
        id: 'AddOneWeek',
        defaultMessage: '+1 week',
    },
    WorkingTime: {
        id: 'WorkingTime',
        defaultMessage: 'Working time',
    },
    Planned: {
        id: 'Planned',
        defaultMessage: 'Planned',
    },
    Available: {
        id: 'Available',
        defaultMessage: 'Available',
    },
    Holiday: {
        id: 'Holiday',
        defaultMessage: 'Holiday',
    },
    CreateNewToDo: {
        id: 'CreateNewToDo',
        defaultMessage: 'Create new to-do',
    },
    PlanTasks: {
        id: 'PlanTasks',
        defaultMessage: 'Plan tasks',
    },
    UnplannedTasks: {
        id: 'UnplannedTasks',
        defaultMessage: 'Unplanned tasks',
    },
    NoUnplannedTasks: {
        id: 'NoUnplannedTasks',
        defaultMessage: 'No unplanned tasks found',
    },
    Filters: {
        id: 'Filters',
        defaultMessage: 'Filters',
    },
    OnlyTasksUserCanStart: {
        id: 'OnlyTasksUserCanStart',
        defaultMessage: 'Only tasks I can start working on',
    },
    OnlyTasksWithDuration: {
        id: 'OnlyTasksWithDuration',
        defaultMessage: 'Only tasks with a duration',
    },
    SelectSubtask: {
        id: 'SelectSubtask',
        defaultMessage: 'Select subtask',
    },
    DeadlineFrom: {
        id: 'DeadlineFrom',
        defaultMessage: 'Deadline from',
    },
    DeadlineUntil: {
        id: 'DeadlineUntil',
        defaultMessage: 'Deadline until',
    },
    Relation: {
        id: 'Relation',
        defaultMessage: 'Relation',
    },
    ResetFilters: {
        id: 'ResetFilters',
        defaultMessage: 'Reset filters',
    },
    CloseFilters: {
        id: 'HideFilters',
        defaultMessage: 'Hide filters',
    },
    DeselectAll: {
        id: 'DeselectAll',
        defaultMessage: 'Deselect all',
    },
    ClosePanel: {
        id: 'ClosePanel',
        defaultMessage: 'Close',
    },
    SelectAll: {
        id: 'SelectAll',
        defaultMessage: 'Select all',
    },
    Monday: {
        id: 'Monday',
        defaultMessage: 'Monday',
    },
    Tuesday: {
        id: 'Tuesday',
        defaultMessage: 'Tuesday',
    },
    Wednesday: {
        id: 'Wednesday',
        defaultMessage: 'Wednesday',
    },
    Thursday: {
        id: 'Thursday',
        defaultMessage: 'Thursday',
    },
    Friday: {
        id: 'Friday',
        defaultMessage: 'Friday',
    },
    Saturday: {
        id: 'Saturday',
        defaultMessage: 'Saturday',
    },
    Sunday: {
        id: 'Sunday',
        defaultMessage: 'Sunday',
    },
    Actions: {
        id: 'Actions',
        defaultMessage: 'Actions',
    },
    GlobalActions: {
        id: 'GlobalActions',
        defaultMessage: 'Global actions',
    },
    SetExecutionDate: {
        id: 'SetExecutionDate',
        defaultMessage: 'Set execution date',
    },
    EmptyExecutionDateHint: {
        id: 'EmptyExecutionDateHint',
        defaultMessage: 'Leave the date empty to remove the execution date.',
    },
    MoveToNextWeek: {
        id: 'MoveToNextWeek',
        defaultMessage: 'Move to next week',
    },
    MoveToNextFreeMoment: {
        id: 'MoveToNextFreeMoment',
        defaultMessage: 'Move to next free moment',
    },
    TasksMoved: {
        id: 'TasksMoved',
        defaultMessage: '{count} task(s) moved',
    },
    TasksUpdated: {
        id: 'TasksUpdated',
        defaultMessage: '{count} task(s) updated',
    },
    PlanProposalTitle: {
        id: 'PlanProposalTitle',
        defaultMessage: 'Proposed planning',
    },
    GeneratingProposal: {
        id: 'GeneratingProposal',
        defaultMessage: 'Calculating proposal...',
    },
    NoProposalRows: {
        id: 'NoProposalRows',
        defaultMessage: 'No proposal could be generated for the selected tasks',
    },
    TaskName: {
        id: 'TaskName',
        defaultMessage: 'Task',
    },
    RelationName: {
        id: 'RelationName',
        defaultMessage: 'Relation',
    },
    Deadline: {
        id: 'Deadline',
        defaultMessage: 'Deadline',
    },
    Duration: {
        id: 'Duration',
        defaultMessage: 'Duration',
    },
    CurrentExecutionDate: {
        id: 'CurrentExecutionDate',
        defaultMessage: 'Current execution date',
    },
    NewExecutionDate: {
        id: 'NewExecutionDate',
        defaultMessage: 'New execution date',
    },
    AcceptAll: {
        id: 'AcceptAll',
        defaultMessage: 'Accept all',
    },
    RejectAll: {
        id: 'RejectAll',
        defaultMessage: 'Reject all',
    },
    AcceptSuggestion: {
        id: 'AcceptSuggestion',
        defaultMessage: 'Accept suggestion',
    },
    RejectSuggestion: {
        id: 'RejectSuggestion',
        defaultMessage: 'Reject suggestion',
    },
    NoFreeMomentFound: {
        id: 'NoFreeMomentFound',
        defaultMessage: 'No free moment found within 8 weeks',
    },
    AfterDeadline: {
        id: 'AfterDeadline',
        defaultMessage: 'After the deadline',
    },
    TasksAfterDeadline: {
        id: 'TasksAfterDeadline',
        defaultMessage: '{count} selected task(s) have a deadline before this date',
    },
    ProposalApplied: {
        id: 'ProposalApplied',
        defaultMessage: '{accepted} task(s) planned, {rejected} skipped',
    },
    AcceptedCount: {
        id: 'AcceptedCount',
        defaultMessage: '{count} accepted',
    },
    RejectedCount: {
        id: 'RejectedCount',
        defaultMessage: '{count} rejected',
    },
    PendingCount: {
        id: 'PendingCount',
        defaultMessage: '{count} pending',
    },
});
export default messages;
